import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import Tooltip from '@mui/material/Tooltip'

type Props = {
  name: string
  data: string
  tooltip: string
}

const Info = ({ data, name, tooltip }: Props) => {
  return (
    <Tooltip title={tooltip} placement="left">
      <Grid item container px={2} py={1}>
        <Grid item xs={6}>
          <Typography>{name}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{data}</Typography>
        </Grid>
      </Grid>
    </Tooltip>
  )
}

export default Info
